import { observer } from 'mobx-react-lite';
import { DefaultButton, IconButton } from '@fluentui/react/lib/Button';
import changeFrom from 'owa-mail-compose-actions/lib/actions/changeFrom';
import removeSendAsAddressFromMru from 'owa-mail-compose-actions/lib/actions/removeSendAsAddressFromMru';
import handleIsFromValid from 'owa-mail-compose-actions/lib/utils/handleIsFromValid';
import { ComposeViewState, FromViewState } from 'owa-mail-compose-store';
import * as React from 'react';

const styles = require('./ComposeFromMenuOption.scss');

interface ComposeFromMenuOptionProps {
    composeViewState: ComposeViewState;
    fromViewState: FromViewState;
    fromAddress: string;
    indexOfFromAddress: number;
    dismissMenuCallback: () => void;
}

const ComposeFromMenuOption = observer(function ComposeFromMenuOption(
    props: ComposeFromMenuOptionProps
) {
    const {
        composeViewState,
        fromViewState,
        fromAddress,
        indexOfFromAddress,
        dismissMenuCallback,
    } = props;

    const onChangeFromCallback = React.useCallback(() => {
        changeFrom(fromViewState, fromAddress);
        handleIsFromValid(composeViewState, fromViewState, true /* isFromValid */);
        dismissMenuCallback();
    }, [fromAddress]);

    const onRemoveFromCallback = React.useCallback(
        () => removeSendAsAddressFromMru(indexOfFromAddress),
        [indexOfFromAddress]
    );

    return (
        <div className={styles.fromMenuOptionWrapper}>
            <DefaultButton
                className={styles.fromMenuOption}
                styles={{ label: styles.fromMenuOptionLabel }}
                text={fromAddress}
                onClick={onChangeFromCallback}
            />
            {indexOfFromAddress !== undefined && (
                <IconButton
                    className={styles.fromMenuOptionRemoveButton}
                    iconProps={{ iconName: 'Cancel' }}
                    onClick={onRemoveFromCallback}
                />
            )}
        </div>
    );
});

export default ComposeFromMenuOption;
